package com.narbase.letsgo.web.views.admin

import com.narbase.letsgo.models.roles.AdminPrivilege
import com.narbase.letsgo.web.BasePageViewModel
import com.narbase.letsgo.web.dto.admin.AdminPrivilegeListDto
import com.narbase.letsgo.web.translations.localized

/**
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2020/01/19.
 */
class AdminTabs(
    val routeDetails: BasePageViewModel.RouteDetails,
    val privileges: Array<AdminPrivilege> = arrayOf()
) {
    ;

    companion object {

        val Staff = AdminTabs(BasePageViewModel.RouteDetails("/staff", "Current Staff".localized()), arrayOf(AdminPrivilege.StaffManagement))
        val Drivers = AdminTabs(BasePageViewModel.RouteDetails("/drivers", "Drivers Management".localized()), arrayOf(AdminPrivilege.DriversManagement))
        val Rides = AdminTabs(BasePageViewModel.RouteDetails("/rides", "Rides".localized()), arrayOf(AdminPrivilege.RidesAccess))

        //        val InActiveStaff = AdminTabs(BasePageViewModel.RouteDetails("/inactive_staff", "Inactive Staff".localized()))
        val Roles = AdminTabs(BasePageViewModel.RouteDetails("/roles", "Roles".localized()), arrayOf(AdminPrivilege.DynamicRoles))
        val AuditLog = AdminTabs(BasePageViewModel.RouteDetails("/audit_log", "Audit log".localized()), arrayOf(AdminPrivilege.AuditLogAccess))
        val DriverProfileGroups =
            AdminTabs(BasePageViewModel.RouteDetails("/driver_profile_groups", "Driver Profile Groups".localized()), arrayOf(AdminPrivilege.DriverProfileGroups))
        val CallCenter = AdminTabs(BasePageViewModel.RouteDetails("/call_center", "Call Center".localized()), arrayOf(AdminPrivilege.CallCenterOperation))
        val PassengerProfileGroups = AdminTabs(
            BasePageViewModel.RouteDetails(
                "/passenger_profile_groups",
                "Passenger Profile Groups".localized()
            ),
            arrayOf(AdminPrivilege.PassengerProfileGroups)
        )
        val Incentive = AdminTabs(BasePageViewModel.RouteDetails("/incentives", "Incentives".localized()), arrayOf())
        val Targets = AdminTabs(BasePageViewModel.RouteDetails("/targets", "Targets".localized()),  arrayOf(AdminPrivilege.DriverTargets))
        val OperationSetting = AdminTabs(BasePageViewModel.RouteDetails("/operation_setting", "Operation Settings".localized()), arrayOf(AdminPrivilege.OperationSettings))
        val BankilyTransfers = AdminTabs(BasePageViewModel.RouteDetails("/bankily_transfers", "Bankily Transfers".localized()), arrayOf(AdminPrivilege.BankilyTransfers))
        val DriverGroups = AdminTabs(BasePageViewModel.RouteDetails("/driver_groups", "Driver Groups".localized()), arrayOf()) //todo: add privilige
        val ContactUs = AdminTabs(BasePageViewModel.RouteDetails("/contact_us", "Contact Us".localized()), arrayOf(AdminPrivilege.AppSettings))
        val Banners = AdminTabs(BasePageViewModel.RouteDetails("/banners", "Banners".localized()), arrayOf(AdminPrivilege.AppSettings))
        val Support = AdminTabs(BasePageViewModel.RouteDetails("/help_and_support", "Help & Support".localized()), arrayOf(AdminPrivilege.AppSettings))
        val LinkShares = AdminTabs(BasePageViewModel.RouteDetails("/link_shares", "Link Shares".localized()), arrayOf(AdminPrivilege.LinkShareManagement))
        val MobileUpdate = AdminTabs(BasePageViewModel.RouteDetails("/mobile_update", "Over The Air Update".localized()), arrayOf(AdminPrivilege.InternalDeveloperConfig))
        val SearchIndex = AdminTabs(BasePageViewModel.RouteDetails("/search_index", "Address Search Index".localized()), arrayOf(AdminPrivilege.SearchIndexManagement))
        val VoiceAssistantSessions = AdminTabs(BasePageViewModel.RouteDetails("/voice_assistant_sessions", "Voice Assistant Sessions".localized()), arrayOf(AdminPrivilege.VoiceAssistantSessions))
        val VoiceAssistant = AdminTabs(BasePageViewModel.RouteDetails("/voice_assistant", "Voice Assistant".localized()), arrayOf(AdminPrivilege.InternalDeveloperConfig))
        val PushPayload = AdminTabs(BasePageViewModel.RouteDetails("/push_payload", "Push Payload Sender".localized()), arrayOf(AdminPrivilege.PushPayloadSending))
        val Analytics = AdminTabs(BasePageViewModel.RouteDetails("/analytics", "Analytics".localized()), arrayOf(AdminPrivilege.InternalDeveloperConfig))
        val PromoCodes = AdminTabs(BasePageViewModel.RouteDetails("/promo_codes", "Promo Codes".localized()), arrayOf(AdminPrivilege.PromoCodeManagement))

        val subLists = listOf(
            AdminTabSubList("Staff Management".localized(), listOf(Staff, /*InActiveStaff,*/ Roles)),
            AdminTabSubList("Operation".localized(), listOf(Drivers, Rides)),
            AdminTabSubList("Call Center".localized(), listOf(CallCenter, VoiceAssistantSessions)),
            AdminTabSubList("Profile Groups".localized(), listOf(DriverProfileGroups, PassengerProfileGroups, Incentive, Targets, DriverGroups, PromoCodes)),
            AdminTabSubList("Bankily".localized(), listOf(BankilyTransfers)),
            AdminTabSubList("General settings".localized(), listOf(AuditLog, OperationSetting, SearchIndex, PushPayload)),
            AdminTabSubList("App settings".localized(), listOf(Banners, ContactUs, Support)),
            AdminTabSubList("Internal Developer Configuration".localized(), listOf(MobileUpdate, VoiceAssistant, Analytics)),
            AdminTabSubList("Link Share".localized(), listOf(LinkShares))
        )
    }
}

class AdminTabSubList(
    val title: String,
    val tabs: List<AdminTabs>
)
